import { useLocation } from "react-router-dom";

function useMatchLocation(path: string, baseUiUrl?: string): boolean {
    let location = useLocation();

    let pathnameToUse = location.pathname;

    if (baseUiUrl !== undefined) {
        pathnameToUse = location.pathname.substring(baseUiUrl.length);
    }

    return (
        pathnameToUse.indexOf(path) === 0 &&
        ["/", ""].indexOf(pathnameToUse.substring(path.length, path.length + 1)) !== -1
    );
}

export default useMatchLocation;
